<template>
  <div class="main-panel">
    <div class="orders-container-v2">
      <!-- Обновленный Заголовок -->
      <div class="page-header-v2">
        <div>
          <h2 class="page-title-v2">
            <i class="fa fa-shopping-cart me-2"></i>Список замовлень
          </h2>
        </div>
        <div class="header-actions">
          <router-link :to="{ name: 'Main' }" class="btn btn-primary">
            <i class="fa fa-plus me-1"></i> Створити замовлення
          </router-link>
        </div>
      </div>

      <!-- Панель фильтров в виде карточки -->
      <div class="card filter-card-v2">
        <div class="card-body">
          <div class="filters-grid-v2">
            <div class="filter-group-v2">
              <label class="filter-label-v2">Дата створення</label>
              <b-form-datepicker v-model="filter.date" reset-button label-reset-button="Скинути"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="uk"
                placeholder="Оберіть дату"></b-form-datepicker>
            </div>

            <div class="filter-group-v2">
              <label class="filter-label-v2">Дата готовності</label>
              <b-form-datepicker v-model="filter.date_ready" reset-button label-reset-button="Скинути"
                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" locale="uk"
                placeholder="Оберіть дату"></b-form-datepicker>
            </div>

            <div class="filter-group-v2 search-group">
              <label class="filter-label-v2">Пошук за текстом</label>
              <b-form-input v-model.lazy="filter.query" type="search" placeholder="Номер, коментар..."></b-form-input>
            </div>

            <div class="filter-group-v2">
              <label class="filter-label-v2">Чернетка</label>
              <b-form-select v-model.number="filter.draft">
                <option value="">Всі</option>
                <option value="1">Так</option>
                <option value="0">Ні</option>
              </b-form-select>
            </div>

            <div class="filter-actions-v2">
              <button class="btn btn-primary" @click="search">
                <i class="fa fa-search me-1"></i> Шукати
              </button>
              <button class="btn btn-outline-danger" @click="reset" title="Скинути фільтри">
                <i class="fa fa-times me-1"></i> Скинути
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Таблица в виде карточки -->
      <div class="card table-card-v2">
        <div class="table-responsive">
          <table class="table orders-table-v2">
            <thead>
              <tr>
                <th>№</th>
                <th>Дата створення</th>
                <th>Список виробів</th>
                <th>Матеріал</th>
                <th>Чернетка</th>
                <th>Коментар</th>
                <th>Замовлення</th>
                <th>Сума грн.</th>
                <th>Дата готовності</th>
                <th class="text-center">Дії</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td colspan="10" class="text-center p-5">
                  <div class="spinner-border text-primary" role="status">
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else-if="orders.length === 0">
              <tr>
                <td colspan="10" class="text-center p-5">
                  <div class="empty-state-v2">
                    <i class="fa fa-inbox"></i>
                    <h4>Немає замовлень</h4>
                    <p>За заданими фільтрами нічого не знайдено.</p>
                  </div>
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="(order, index) in orders" :key="order.id">
                <td>{{ index + 1 }}</td>
                <td>{{ formatDate(order.created_at) }}</td>
                <td>
                  <span class="product-list-v2" :title="getProductsList(order)">
                    {{ truncateText(getProductsList(order), 30) }}
                  </span>
                </td>
                <td>
                  <div class="material-cell-v2" @mouseenter="showMaterialTooltip($event, order)"
                    @mouseleave="hideMaterialTooltip">
                    <span class="material-name-v2">
                      {{ truncateText(getDefaultMaterial(order), 300) }}
                    </span>
                  </div>
                </td>
                <td>
                  <span :class="['badge-v2', order.draft == 1 ? 'badge-draft' : 'badge-ready']">
                    {{ order.draft == 1 ? "Так" : "Ні" }}
                  </span>
                </td>
                <td>{{ truncateText(order.comment, 40) }}</td>
                <td>
                  <span class="doc-no-v2">{{ order.doc_no || '—' }}</span>
                </td>
                <td class="text-end">
                  <span class="sum-with-info">
                    {{ formatCurrency(sum(order)) }}
                    <span v-if="hasNoPriceItems(order) && order.draft == 0"
                      v-b-tooltip.hover.top="'Остаточна сума та дата готовності замовлення буде уточнена менеджером'">
                      <i class="fa fa-exclamation-triangle sum-info-icon"></i>
                    </span>
                  </span>
                </td>
                <td>{{ formatDate(order.date_ready) }}</td>
                <td class="text-center">
                  <div class="btn-group btn-group-sm">
                    <router-link :to="{ name: 'order-edit', params: { id: order.id } }" class="btn btn-outline-primary"
                      :title="order.doc_no ? 'Копіювати' : 'Редагувати'">
                      <i :class="['fa', order.doc_no ? 'fa-copy' : 'fa-pen']"></i>
                    </router-link>
                    <button v-if="!order.doc_no" @click="deleteOrder(order)" class="btn btn-outline-danger"
                      title="Видалити">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-footer" v-if="rows > perPage">
          <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="orders-table"
            align="center" size="sm"></b-pagination>
        </div>
      </div>

      <!-- Material Tooltip -->
      <div v-if="materialTooltip.visible" class="material-tooltip-v2" :style="materialTooltip.style">
        <div v-if="materialTooltip.material" class="tooltip-content-v2">
          <div class="tooltip-image-v2">
            <img :src="appconfig.Point + `/` + materialTooltip.material.image"
              :alt="materialTooltip.material.full_name_ukr" />
          </div>
          <div class="tooltip-info-v2">
            <div v-if="materialTooltip.material.on_order" class="tooltip-badge-v2">Під замовлення</div>
            <h5 class="tooltip-title-v2">{{ materialTooltip.material.full_name_ukr }}</h5>
            <div class="tooltip-meta-v2">
              <span class="tooltip-code-v2">Код: {{ materialTooltip.material.code }}</span>
              <span class="tooltip-status-v2"
                :class="materialTooltip.material.quantity == 0 ? 'status-order' : 'status-stock'">
                <i :class="materialTooltip.material.quantity == 0 ? 'fa fa-truck' : 'fa fa-check-circle'"></i>
                {{ materialTooltip.material.quantity == 0 ? 'Термін постачання до: ' +
                  materialTooltip.material.term_order + ' дн.' : 'В наявності' }}
              </span>
            </div>
            <div v-if="materialTooltip.material.price > 0" class="tooltip-price-v2">
              <span class="price-value-v2">{{ materialTooltip.material.p }}</span>
              <span class="price-currency-v2">{{ materialTooltip.material.cy_name }} / {{
                materialTooltip.material.base_unit_name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import appconfig from "../../app/config";
import { orderService } from "../../services/orderService";

export default {
  data() {
    return {
      appconfig: appconfig,
      filter: {
        draft: '',
        date_ready: '',
        date: '',
        query: '',
      },
      loading: false,
      currentPage: 1,
      rows: 0,
      perPage: 0,
      orders: [],
      timer: null,
      materialTooltip: {
        visible: false,
        material: null,
        style: {}
      }
    }
  },
  created() {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData',
    currentPage(newVal, oldVal) {
      this.fetchData('&' + new URLSearchParams(this.filter).toString());
    },
  },
  methods: {
    reset() {
      this.filter = {
        draft: '',
        date_ready: '',
        date: '',
        query: '',
      }
      this.fetchData('&' + new URLSearchParams(this.filter).toString());
    },
    search() {
      this.currentPage = 1;
      this.fetchData('&' + new URLSearchParams(this.filter).toString());
    },
    sum(order) {
      let sum = 0;
      if (order.order_items != undefined) {
        order.order_items.forEach((p) => {
          sum += p.sum;
        })
      }
      return Number(sum).toFixed(2);
    },
    hasNoPriceItems(order) {
      // Проверяем материалы без цены
      if (order.order_items && order.order_items.length > 0) {
        const hasNoPriceMaterial = order.order_items.some(item => {
          const price = item.sum;
          return price === 0 || price === null || price === undefined;
        });
        if (hasNoPriceMaterial) return true;
      }

      // Проверяем кромки без цены
      if (order.edges_list && order.edges_list.length > 0) {
        const hasNoPriceEdge = order.edges_list.some(edge => {
          const price = edge.price || edge.pr;
          return price === 0 || price === null || price === undefined;
        });
        if (hasNoPriceEdge) return true;
      }

      return false;
    },
    deleteOrder(order) {
      if (confirm('Ви впевнені?')) {
        this.loading = true;
        axios.get(
          appconfig.Point + 'api/constructor/v1/order/delete/' + order.id
        ).then(response => {
          this.loading = false;
          this.$toast.success(response.data.message);
          this.fetchData();
        })
          .catch(r => {
            this.$toast.error('Щось пішло не так =(')
            this.loading = false;
          })
      }
    },
    fetchData(params = '') {
      this.loading = true;
      params = '?page=' + this.currentPage + params;
      orderService.getList(params)
        .then(response => {
          this.loading = false;
          this.orders = response.data;
          this.perPage = response.meta.per_page;
          this.rows = response.meta.total;
        })
    },
    // Новые методы для улучшенного отображения
    getProductsList(order) {
      return order.items
        .filter(item => item.name !== '' && item.name != null)
        .map(item => item.name)
        .filter((v, i, self) => i == self.indexOf(v))
        .join(', ');
    },
    getDefaultMaterial(order) {
      if (!order.materials_list || order.materials_list.length === 0) {
        return '—';
      }
      const defaultMaterial = order.materials_list.find(material => material.is_default == true);
      return defaultMaterial ? defaultMaterial.full_name_ukr : '—';
    },
    getDefaultMaterialObject(order) {
      if (!order.materials_list || order.materials_list.length === 0) {
        return null;
      }
      return order.materials_list.find(material => material.is_default == true) || null;
    },
    showMaterialTooltip(event, order) {
      const material = this.getDefaultMaterialObject(order);
      if (!material) return;

      const rect = event.target.getBoundingClientRect();
      const tooltipWidth = 400;
      const tooltipHeight = 200;

      let left = rect.left + window.scrollX + rect.width / 2 - tooltipWidth / 2;
      let top = rect.bottom + window.scrollY + 10;

      // Проверяем, не выходит ли тултип за правый край экрана
      if (left + tooltipWidth > window.innerWidth) {
        left = window.innerWidth - tooltipWidth - 20;
      }

      // Проверяем, не выходит ли за левый край
      if (left < 10) {
        left = 10;
      }

      // Проверяем, не выходит ли за нижний край экрана
      if (top + tooltipHeight > window.innerHeight + window.scrollY) {
        top = rect.top + window.scrollY - tooltipHeight - 10;
      }

      this.materialTooltip = {
        visible: true,
        material: material,
        style: {
          left: left + 'px',
          top: top + 'px'
        }
      };
    },
    hideMaterialTooltip() {
      this.materialTooltip.visible = false;
    },
    formatDate(dateString) {
      if (!dateString) return '—';
      // const date = new Date(dateString);
      // return date.toLocaleDateString('uk-UA', { day: '2-digit', month: '2-digit', year: 'numeric' });
      return dateString;
    },
    formatCurrency(amount) {
      return amount;
    },
    truncateText(text, maxLength) {
      if (!text) return '—';
      return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    }
  },
  name: "order-list"
}
</script>

<style scoped>
.orders-container-v2 {
  max-width: 1600px;
  margin: 20px auto;
  padding: 0;
}

.page-header-v2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #dee2e6;
}

.page-title-v2 {
  font-size: 1.75rem;
  font-weight: 600;
  color: #343a40;
  margin: 0;
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: center;
}

.page-subtitle-v2 {
  font-size: 0.9rem;
  color: #2c5aa0;
  margin-top: 0.25rem;
}

.header-actions .btn {
  padding: 0.6rem 1.2rem;
  font-size: 0.9rem;
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card {
  border: none;
  border-radius: 0.75rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 2rem;
}

.filter-card-v2 .card-header {
  background-color: white;
  border-bottom: 1px solid #dee2e6;
  font-weight: 500;
  padding: 1rem 1.5rem;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.filter-card-v2 .card-body {
  padding: 1.5rem;
}

.filters-grid-v2 {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr 1fr auto;
  gap: 1.5rem;
  align-items: flex-end;
}

.search-group {
  grid-column: span 1;
  /* Search input can take more space if needed */
}

.filter-group-v2 {
  display: flex;
  flex-direction: column;
}

.filter-label-v2 {
  font-size: 0.875rem;
  margin-bottom: 0.5rem;
  color: #2c5aa0;
  font-weight: 500;
}

.filter-actions-v2 {
  display: flex;
  gap: 0.5rem;
}

.filter-actions-v2 .btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.55rem 1rem;
  gap: 10px;
}

/* Button styles - новые цвета и простота */
.btn-primary {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #1e4a8a;
  border-color: #1e4a8a;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.btn-outline-secondary {
  color: #2c5aa0;
  border-color: #2c5aa0;
  background: transparent;
  transition: all 0.3s ease;
}

.btn-outline-secondary:hover {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.btn-outline-primary {
  color: #2c5aa0;
  border-color: #2c5aa0;
  background: transparent;
  transition: all 0.3s ease;
}

.btn-outline-primary:hover {
  background-color: #2c5aa0;
  border-color: #2c5aa0;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(44, 90, 160, 0.3);
}

.btn-outline-danger {
  color: #dc3545;
  border-color: #dc3545;
  background: transparent;
  transition: all 0.3s ease;
}

.btn-outline-danger:hover {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 53, 69, 0.3);
}

/* Table styles */
.table-card-v2 {
  overflow: hidden;
}

.orders-table-v2 {
  width: 100%;
  margin-bottom: 0;
  font-size: 0.85rem;
  /* Smaller font size */
  border-collapse: collapse;
  table-layout: fixed;
}

.orders-table-v2 thead {
  background-color: #f8f9fa;
}

.orders-table-v2 th,
.orders-table-v2 td {
  border: 1px solid #dee2e6;
  padding: 0.6rem 0.8rem;
  /* Reduced padding */
  vertical-align: middle;
}

.orders-table-v2 th {
  font-weight: 600;
  color: #2c3e50;
  border-top: none;
  border-bottom: 2px solid #2c5aa0;
  background: #f8f9fa;
  white-space: nowrap;
}

/* Adjust column widths for better fit */
.orders-table-v2 th:nth-child(1),
/* № */
.orders-table-v2 td:nth-child(1) {
  width: 30px;
  text-align: center;
  padding: 5px;
}

.orders-table-v2 th:nth-child(2),
/* Дата створення */
.orders-table-v2 td:nth-child(2) {
  width: 120px;
}

.orders-table-v2 th:nth-child(3),
/* Список виробів */
.orders-table-v2 td:nth-child(3) {
  width: 160px;
}

.orders-table-v2 th:nth-child(4),
/* Матеріал */
.orders-table-v2 td:nth-child(4) {
  width: 200px;
}

.orders-table-v2 th:nth-child(5),
/* Статус */
.orders-table-v2 td:nth-child(5) {
  width: 70px;
  text-align: center;
  padding: 0;
}

.orders-table-v2 th:nth-child(6),
/* Коментар */
.orders-table-v2 td:nth-child(6) {
  width: 120px;
}

.orders-table-v2 th:nth-child(7),
/* Номер замовлення */
.orders-table-v2 td:nth-child(7) {
  width: 110px;
  text-align: center;
}

.orders-table-v2 th:nth-child(8),
/* Сума замовлення */
.orders-table-v2 td:nth-child(8) {
  width: 100px;
  text-align: left;
}

.orders-table-v2 th:nth-child(9),
/* Дата готовності */
.orders-table-v2 td:nth-child(9) {
  width: 120px;
}

.orders-table-v2 th:nth-child(10),
/* Дії */
.orders-table-v2 td:nth-child(10) {
  width: 70px;
  text-align: center;
  padding: 5px;
}

.orders-table-v2 tbody tr {
  transition: background-color 0.2s ease;
}

.orders-table-v2 tbody tr:nth-of-type(odd) {
  background-color: white;
}

.orders-table-v2 tbody tr:nth-of-type(even) {
  background-color: #f8f9fa;
}

.orders-table-v2 tbody tr:hover {
  background-color: rgba(44, 90, 160, 0.05);
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.product-list-v2 {
  font-style: italic;
  color: #2c5aa0;
}

.material-cell-v2 {
  cursor: pointer;
  position: relative;
}

.material-name-v2 {
  color: #6c757d;
  font-size: 0.85rem;
}

.material-cell-v2:hover .material-name-v2 {
  color: #2c5aa0;
  text-decoration: underline;
}

/* Material Tooltip */
.material-tooltip-v2 {
  position: absolute;
  z-index: 10000;
  background: white;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  width: 400px;
  max-width: 90vw;
  pointer-events: none;
  animation: tooltipFadeIn 0.2s ease-out;
}

@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(-5px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.tooltip-content-v2 {
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 16px;
  padding: 16px;
}

.tooltip-image-v2 {
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tooltip-image-v2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.tooltip-info-v2 {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tooltip-badge-v2 {
  display: inline-block;
  background: linear-gradient(135deg, #ffd700 0%, #ffed4e 100%);
  color: #856404;
  padding: 4px 10px;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
  box-shadow: 0 2px 4px rgba(255, 193, 7, 0.3);
}

.tooltip-title-v2 {
  font-size: 0.95rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
  line-height: 1.3;
}

.tooltip-meta-v2 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.tooltip-code-v2 {
  font-size: 0.75rem;
  color: #6c757d;
  font-family: monospace;
}

.tooltip-status-v2 {
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  padding: 2px 8px;
  border-radius: 6px;
}

.tooltip-status-v2.status-stock {
  color: #198754;
}

.tooltip-status-v2.status-stock i {
  color: #198754;
}

.tooltip-status-v2.status-order {
  color: #dc3545;
}

.tooltip-status-v2.status-order i {
  color: #dc3545;
}

.tooltip-price-v2 {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-top: 4px;
  padding-top: 8px;
  border-top: 1px solid #e9ecef;
}

.price-value-v2 {
  font-size: 1.1rem;
  font-weight: 700;
  color: #2c5aa0;
}

.price-currency-v2 {
  font-size: 0.8rem;
  color: #6c757d;
  font-weight: 500;
}

.price-unit-v2 {
  font-size: 0.75rem;
  color: #adb5bd;
}

.sum-with-info {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.sum-info-icon {
  color: #ffc107;
  font-size: 0.9rem;
  cursor: help;
}

.sum-info-icon:hover {
  color: #ff9800;
}

.badge-v2 {
  padding: 0.3em 0.6em;
  /* Adjusted padding */
  border-radius: 0.25rem;
  font-weight: 500;
  font-size: 0.7rem;
  /* Adjusted font size */
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-draft {
  background-color: #ffc107;
  color: #212529;
}

.badge-ready {
  background-color: #198754;
  color: white;
}

.doc-no-v2 {
  font-weight: 500;
  font-family: monospace;
  color: #2c5aa0;
}

.empty-state-v2 {
  color: #2c5aa0;
}

.empty-state-v2 i {
  font-size: 3rem;
  margin-bottom: 1rem;
  color: #ced4da;
}

.table-card-v2 .card-footer {
  background-color: white;
  border-top: 1px solid #dee2e6;
  padding: 1rem;
}

/* Медиа-запрос для экранов меньше 1366px */
@media (max-width: 1365px) {
  .filter-card-v2 .card-body {
    padding: 1rem;
  }

  .filters-grid-v2 {
    grid-template-columns: 1fr 1fr 1.5fr 1fr auto;
    gap: 0.75rem;
    padding: 0.5rem;
    font-size: 0.8rem;
  }

  .filter-label-v2 {
    font-size: 0.75rem;
    margin-bottom: 0.25rem;
  }

  .filter-group-v2 input,
  .filter-group-v2 select,
  .filter-group-v2 .form-control {
    font-size: 0.8rem;
  }

  .filter-group-v2 .form-select {
    height: 2rem;
    min-height: 2rem;
  }

  .filter-group-v2 .b-form-datepicker {
    height: 2rem;
  }

  .filter-group-v2 .b-form-datepicker .form-control {
    height: 2rem !important;
    font-size: 0.8rem !important;
    padding: 0.25rem 0.5rem !important;
    line-height: 1.2 !important;
  }

  .filter-group-v2 .b-form-datepicker .form-control::placeholder {
    font-size: 0.8rem !important;
    line-height: 1.2 !important;
  }

  .filter-group-v2 .b-form-datepicker .btn {
    height: 2rem !important;
    padding: 0.25rem !important;
  }

  .filter-actions-v2 .btn {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
    height: 2rem;
  }

  .orders-table-v2 {
    font-size: 0.75rem;
  }

  .orders-table-v2 th,
  .orders-table-v2 td {
    padding: 0.4rem 0.5rem;
  }

  /* Уменьшаем ширину колонок */
  .orders-table-v2 th:nth-child(2),
  .orders-table-v2 td:nth-child(2) {
    width: 100px;
  }

  .orders-table-v2 th:nth-child(3),
  .orders-table-v2 td:nth-child(3) {
    width: 140px;
  }

  .orders-table-v2 th:nth-child(4),
  .orders-table-v2 td:nth-child(4) {
    width: 180px;
  }

  .orders-table-v2 th:nth-child(6),
  .orders-table-v2 td:nth-child(6) {
    width: 100px;
  }

  .orders-table-v2 th:nth-child(7),
  .orders-table-v2 td:nth-child(7) {
    width: 90px;
  }

  .orders-table-v2 th:nth-child(8),
  .orders-table-v2 td:nth-child(8) {
    width: 80px;
  }

  .orders-table-v2 th:nth-child(9),
  .orders-table-v2 td:nth-child(9) {
    width: 100px;
  }

  .orders-table-v2 th:nth-child(10),
  .orders-table-v2 td:nth-child(10) {
    width: 60px;
  }

  .btn-group-sm .btn {
    padding: 0.2rem 0.4rem;
    font-size: 0.7rem;
  }

  .btn-group-sm {
    gap: 0.2rem;
  }
}
</style>